import { useResource } from '@lp/features/RoutePlanner/hooks/useResource';
import { useCaseDetailsWithReviews } from '@lp/features/RoutePlanner/hooks/useCaseDetailsWithReviews';
import { CaseFacility, CaseResourceType } from '@/api/apis/case';
import { RouteResourceCard } from './RouteResourceCard';

type OcsDeviceCardProps = {
  id?: string;
  donorHospital?: CaseFacility;
  disabled?: boolean;
};

export const OcsDeviceCard = ({ id = '', donorHospital, disabled }: OcsDeviceCardProps) => {
  const { organType } = useCaseDetailsWithReviews();
  const { resource, resourceData, handleAssignModal, handleViewResourceModal } = useResource({
    type: CaseResourceType.OCSConsole,
    id,
    donorHospital,
  });

  return (
    <div className="w-48 shrink-0">
      <RouteResourceCard
        type="device"
        hasResource={!!resource}
        imageUrl={resourceData.imageUrl}
        title={resourceData.title}
        statusType={resourceData.statusType}
        status={resource?.logisticsStatus}
        subTitle={resourceData.subTitle}
        statusText={resourceData.statusText}
        showAssignButton={resourceData.showAssignButton}
        organType={resource ? organType : undefined}
        onOpen={handleAssignModal}
        onClick={disabled ? () => null : handleViewResourceModal}
      />
    </div>
  );
};
